import GetColor from "./GetColor";

export default function ConvertSalesToDataset(departmentList, departmentSales, dataIndex) {
    if (!(departmentList instanceof Array)) throw new Error("Departmentlist is not an array")
    if (!(departmentSales instanceof Array)) throw new Error("DepartmentSales is not an array");
    if (typeof dataIndex !== 'string') throw new Error("DataIndex is not a string");

    const toReturn = [];

    // Loop each department, then loop through each sale in said department
    departmentSales.forEach(departmentSale => {
        const name = departmentList.find(department => department.id == departmentSale[0].departmentId).name;
        const color = GetColor(name);

        const toAdd = {
            label: name,
            data: [],

            // Styling,
            fill: color,
            backgroundColor: color,
            borderColor: color,

            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',

            tension: 0
        }

        departmentSale.forEach(sale => {
            toAdd.data.push(sale[dataIndex]);
        });

        toReturn.push(toAdd);
    });

    return toReturn;
}


// WEBPACK FOOTER //
// ./src/js/ConvertSalesToDataset.js